exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.copyright[data-v-67b204f4] {\n    padding: 10px;\n}\n.btn-height[data-v-67b204f4] {\n    line-height: 48px;\n}\n.footer-link[data-v-67b204f4] {\n    color: white;\n}\n", ""]);

// exports
